import React, { Component } from "react";
import { connect } from "react-redux";
import {Container, Col, Row, FormGroup, Form, Input, Button, Label, Alert} from 'reactstrap';
import * as usuario from "../../actions/usuario";
import Loading from "../share/Loading";

class FormUsuarios extends Component {

    constructor(props){
        super(props);
        this.state = {
            usuario: {},
            estadoFormulario: 'crear', // 'editar' o 'crear',
            alertInfo: false,
            alertInfoMensaje: ''
        };
        this.handleSubmit = this.handleSubmit.bind(this);
        this.cambioDatosUsuario = this.cambioDatosUsuario.bind(this);
        this.clearUsuario = this.clearUsuario.bind(this);
    }

    handleSubmit = (e) => {
        e.preventDefault();
        if(this.state.usuario.password === ''){
            delete this.state.usuario.password
        }
        if(this.state.estadoFormulario === 'editar'){
            this.props.editUsuario(this.state.usuario);
        }else {
            let usuario = this.state.usuario;
            delete usuario.id;
            usuario.rol_id = 2;
            this.props.addUsuario(this.state.usuario);
        }
        this.clearUsuario();
    };

    componentDidUpdate(prevProps){
        if(!!this.props.usuario){
            if(this.props.usuario !== prevProps.usuario){
                let stateCopy = Object.assign({}, this.state);
                stateCopy['usuario']['nombre_completo'] = this.props.usuario.nombre_completo;
                stateCopy['usuario']['numero_identificacion'] = this.props.usuario.numero_identificacion;
                stateCopy['usuario']['correo'] = this.props.usuario.correo;
                stateCopy['usuario']['activo'] = this.props.usuario.activo;
                stateCopy['usuario']['id'] = this.props.usuario.id;
                stateCopy['estadoFormulario'] = 'editar';
                stateCopy['alertInfo'] = false;
                this.setState(stateCopy);
            }
        }
    }

    cambioDatosUsuario(propiedad, valor){
        let stateCopy = Object.assign({}, this.state);
        stateCopy['usuario'][propiedad] = valor;
        this.setState(stateCopy);
    }

    clearUsuario() {
        let stateCopy = Object.assign({}, this.state);
        stateCopy['usuario']['nombre_completo'] = "";
        stateCopy['usuario']['numero_identificacion'] = "";
        stateCopy['usuario']['correo'] = "";
        stateCopy['usuario']['activo'] = "0";
        stateCopy['usuario']['password'] = "";
        stateCopy['usuario']['id'] = "";
        stateCopy['estadoFormulario'] = 'crear';
        this.setState(stateCopy);
        this.setState({alertInfo: false});
    }

    componentWillReceiveProps(nextProps, nextContext) {
        console.log('propss', nextProps)
        if(nextProps.loading_edit_new_user === false && nextProps.message_edit_new_user !== null){
            this.props.listarUsuarios();
            this.setState({alertInfo: true, alertInfoMensaje: nextProps.message_edit_new_user});
        }
    }

    render(){

        const {loading_edit_new_user} = this.props;

        return(
            <div>
                <Container>
                    <Row>

                        <Col md={{size: 10, offset: 1}} className={this.state.alertInfo === true ? 'mt-2 ' : 'mt-0'}>
                            <Alert color="info" exit={true} isOpen={this.state.alertInfo}>
                                <Container fluid>
                                    <h6 className="text-center">{this.state.alertInfoMensaje}</h6>
                                </Container>
                            </Alert>
                        </Col>

                        <Form className="w-100" onSubmit={this.handleSubmit}>
                            <FormGroup className="form-group mt-2">
                                <Input type="number" name="numero_identificacion" id="numero_identificacion" placeholder="Cédula" value={this.state.usuario.numero_identificacion} onChange={e => this.cambioDatosUsuario('numero_identificacion', e.target.value)}/>
                            </FormGroup>
                            <FormGroup className="form-group">
                                <Input type="text" name="nombre" id="nombre" placeholder="Nombre completo" value={this.state.usuario.nombre_completo} onChange={e => this.cambioDatosUsuario('nombre_completo', e.target.value)}/>
                            </FormGroup>
                            <FormGroup className="form-group">
                                <Input type="email" name="email" id="email" placeholder="Correo electrónico" value={this.state.usuario.correo} onChange={e => this.cambioDatosUsuario('correo', e.target.value)}/>
                            </FormGroup>
                            <FormGroup className="form-group">
                                <Input type="password" name="password" id="password" placeholder="Contraseña" value={this.state.usuario.password} onChange={e => this.cambioDatosUsuario('password', e.target.value)}/>
                            </FormGroup>
                            <FormGroup className="form-group">
                                <Row>
                                    <Col md={2}>
                                        <Label className="col-sm-2 col-form-label" for="estado">Estado</Label>
                                    </Col>
                                    <Col md={10}>
                                        <Input type="select" name="localidad" id="localidad" value={(this.state.usuario.activo === true || this.state.usuario.activo === '1') ? '1' : '0'}
                                               onChange={e => this.cambioDatosUsuario('activo', e.target.value)}>
                                            <option value='ninguno'>Seleccione un estado {this.state.usuario.activo}</option>
                                            <option value='1'>Activo</option>
                                            <option value='0'>Inactivo</option>
                                        </Input>
                                    </Col>
                                </Row>
                            </FormGroup>
                            <Row>
                                <Col md={(this.state.estadoFormulario === 'editar' && !!this.state.usuario.numero_identificacion) ? 6 : 12} className="text-center">
                                    {
                                        (loading_edit_new_user) ? <Loading/> :
                                            <Button type="submit">
                                                {
                                                    (this.state.estadoFormulario === 'crear') ? 'Crear usuario' : 'Actualizar usuario'
                                                }
                                            </Button>
                                    }

                                </Col>
                                {
                                    (this.state.estadoFormulario === 'editar' && !!this.state.usuario.numero_identificacion) ?
                                        <Col md="6" className="text-center">
                                            <Button onClick={this.clearUsuario}>Nuevo usuario</Button>
                                        </Col> : ''
                                }
                            </Row>
                        </Form>
                    </Row>
                </Container>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        loading_edit_new_user: state.usuario.loading_edit_new_user,
        message_edit_new_user: state.usuario.message_edit_new_user
    };
};

const mapDispatchToProps = dispatch => {
    return {
        editUsuario: (data) => {
            return dispatch(usuario.editUsuario(data));
        },
        addUsuario: (data) => {
            return dispatch(usuario.addUsuario(data));
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(FormUsuarios);